export default __webpack_public_path__ + "static/media/community.dbe1b788.svg";